<pre *ngIf="notFound">{{notFound}}</pre>
<ul>
  <li *ngFor="let cssClass of cssClasses" [title]="cssClass.declarations">
    {{cssClass.selector}}
    <div *ngIf="cssClass.selector.startsWith('.col')
      || cssClass.selector.startsWith('.min-')
      || cssClass.selector.startsWith('.mx-')
      || cssClass.selector.startsWith('.wx-')
      || cssClass.selector.startsWith('.hx-')
      || cssClass.selector.startsWith('.m-') && !cssClass.selector.startsWith('.m-n')
      || cssClass.selector.startsWith('.my-') && !cssClass.selector.startsWith('.my-n')
      || cssClass.selector.startsWith('.mt-') && !cssClass.selector.startsWith('.mt-n')
      || cssClass.selector.startsWith('.me-')
      || cssClass.selector.startsWith('.mb-') && !cssClass.selector.startsWith('.mb-n')
      || cssClass.selector.startsWith('.ms-')
      || cssClass.selector.startsWith('.px-')
      || cssClass.selector.startsWith('.py-') && !cssClass.selector.startsWith('.py-n')
      || cssClass.selector.startsWith('.pt-') && !cssClass.selector.startsWith('.pt-n')
      || cssClass.selector.startsWith('.pe-')
      || cssClass.selector.startsWith('.pb-') && !cssClass.selector.startsWith('.pb-n')
      || cssClass.selector.startsWith('.ps-')
      || cssClass.selector.startsWith('.w-')
      || cssClass.selector.startsWith('.h-')
      || cssClass.selector.startsWith('.vw-')
      || cssClass.selector.startsWith('.vh-')"
      class="bg-gray {{cssClass.selector.substring(1)}}">
      Sample text
    </div>
    <button *ngIf="cssClass.selector.startsWith('.btn')" class="btn {{cssClass.selector.substring(1)}}">Button</button>
    <div *ngIf="cssClass.selector.startsWith('.text-')
      || cssClass.selector.startsWith('.bg-')
      || cssClass.selector.startsWith('.font-')
      || cssClass.selector.startsWith('.border-')
      || cssClass.selector.startsWith('.bt-')
      || cssClass.selector.startsWith('.be-')
      || cssClass.selector.startsWith('.bb-')
      || cssClass.selector.startsWith('.bs-')
      || cssClass.selector.startsWith('.by-')
      || cssClass.selector.startsWith('.bx-')
      || cssClass.selector.startsWith('.b-')"
      class="{{cssClass.selector.substring(1)}}">
      Sample text
    </div>
  </li>
</ul>
